import {ISortPoles} from "../models/advanseFilter";
import {isPoleName, isSortType} from "./typeChecker";

export const parseSortPoles = (paramString:string | null):ISortPoles => {

    if(paramString == null)
    {
        return {sortPoles:[{poleName:'year',sortType:"desc"}]};
    }

    let sortPoles:ISortPoles = {sortPoles:[]}

    paramString.split('|').map(params => {
        let values = params.split('-')
        if(values.length == 2)
        {
            if(isPoleName(values[0]) && isSortType(values[1]))
            {
                sortPoles.sortPoles.push({poleName:values[0], sortType:values[1]})
            }
        }
    })

    console.log(sortPoles);
    return sortPoles;
}
